<div
  dndEffectAllowed="copyMove"
  dndType="group"
  [attr.data-list-tasks-group-id]="group().taskGroup.id"
  [dndDraggable]="disableGroupDrag() || isProcessGroup() ? null : { groupId: group().taskGroup.id }"
  [dndDisableIf]="disableGroupDrag() || isProcessGroup()"
  class="list-tasks-group"
  [class.list-tasks-group--card]="layout() !== 'standard' && !isProcessGroup()"
>
  @if (!disableGroupDrag() && !isProcessGroup()) {
    <div dndHandle class="list-tasks-group__draggable">
      <img width="15" src="./assets/img/ic-sortdragchange.svg" alt="drag-drop" />
    </div>
  }

  <div class="list-tasks-group__wrapper">
    <div class="list-tasks-group__header">
      <div class="list-tasks-group__header__title">
        @if (showAccordionToggle()) {
          <div class="list-tasks-group__header__title-expander">
            <expander [opened]="expanded()" size="large" (onClick)="onAccordionToggle()" />
          </div>
        }

        <div class="mr-2 list-tasks-group__header__title-edit">
          @if (canEditGroupName) {
            <img
              class="cursor-pointer"
              [src]="'./assets/img/ic-edit-' + (canEditGroupName ? '3' : '3-grey') + '.svg'"
              (click)="onEditGroupName()"
              alt="edit"
            />
          }
        </div>

        <h4>
          @if (isTemplateGroup()) {
            {{
              group().taskGroup.name
                ? group().taskGroup.name
                : ('ProjectsDashboard.stageTasks.processTasksGroupLabel' | translate)
            }}
          } @else {
            {{ group().taskGroup.name === 'general' ? 'Allgemein' : group().taskGroup.name }}
          }
        </h4>

        <div
          class="list-tasks-group__header__title-progress"
          [attr.aria-label]="
            'ProjectsDashboard.stageTasks.groupProgress.ariaLabel' | translate: {
              completed: groupCompletedCount(),
              total: groupTotalCount()
            }
          "
        >
          <img
            [src]="
              layout() === 'my-work'
                ? './assets/img/ic-24h.svg'
                : './assets/img/ic-checkmark-circle-outline-primary.svg'
            "
            [class.my-work-progress-icon]="layout() === 'my-work'"
            alt=""
            aria-hidden="true"
          />
          <strong>
            {{
              'ProjectsDashboard.stageTasks.groupProgress.completed'
                | translate: { count: groupCompletedCount() }
            }}
          </strong>
          <span class="list-tasks-group__header__title-progress-separator" aria-hidden="true"></span>
          <span class="list-tasks-group__header__title-progress-total">
            {{ 'ProjectsDashboard.stageTasks.groupProgress.total' | translate: { count: groupTotalCount() } }}
          </span>
        </div>
      </div>

      <div class="list-tasks-group__header__actions">
        @if (isTemplateGroup()) {
          <!-- TODO: Temporary hidden, unlock when client ready -->
          <!-- <button type="button" class="list-tasks-group__header__add" [matMenuTriggerFor]="templateAddMenu">
            <img src="./assets/img/ic-plus-add.svg" alt="add" />
          </button>

          <mat-menu #templateAddMenu="matMenu" xPosition="before" class="menu-v2">
            @for (item of templateAddMenuItems; track item.key) {
              <button mat-menu-item (click)="onTemplateAddOptionSelected(item.key)">
                <span>{{ item.translationKey | translate }}</span>
              </button>
            }
          </mat-menu> -->
        } @else if (layout() === 'my-work') {
          <button
            type="button"
            class="list-tasks-group__header__add"
            [matMenuTriggerFor]="myWorkAddMenu"
            [attr.aria-label]="'MyWork.addItem' | translate"
          >
            <img src="./assets/img/ic-plus-add.svg" alt="" aria-hidden="true" />
          </button>
          <mat-menu #myWorkAddMenu="matMenu" xPosition="before" class="menu-v2">
            @for (type of myWorkTaskTypes; track type) {
              <button mat-menu-item type="button" (click)="openTypedAddTask(type)">
                {{ 'TaskType.' + type | translate }}
              </button>
            }
          </mat-menu>
        } @else {
          <button type="button" class="list-tasks-group__header__add" (click)="openAddTask()">
            <img src="./assets/img/ic-plus-add.svg" alt="add" />
          </button>
        }
      </div>

    </div>

    @if (shouldRenderContent) {
      <div
        class="list-tasks-group__content"
        [class.list-tasks-group__content--process]="isProcessGroup()"
        [dndDropzone]="isProcessGroup() ? [] : ['task']"
        (dndDrop)="onTaskDrop($event, 'created')"
      >
        <div dndPlaceholderRef class="dndPlaceholder"></div>

        @if (isProcessGroup() && !getTargetCollection('created').length) {
          <div class="list-tasks-group__process-insert-slot">
            <div class="list-tasks-group__process-insert-slot__line"></div>

            <div class="list-tasks-group__process-insert-slot__actions">
              <button
                type="button"
                class="list-tasks-group__process-insert-slot__action-btn list-tasks-group__process-insert-slot__action-btn--task"
                (click)="onProcessInsertSelected(0, 'task')"
              >
                <mat-icon>check</mat-icon>
              </button>

              <button
                type="button"
                class="list-tasks-group__process-insert-slot__action-btn list-tasks-group__process-insert-slot__action-btn--message"
                (click)="onProcessInsertSelected(0, 'message')"
              >
                <img src="./assets/img/ic-mail.svg" alt="add message" />
              </button>
            </div>
          </div>
        }

        @for (task of getTargetCollection('created'); track task.id; let idx = $index; let last = $last) {
          @if (isProcessGroup()) {
            <div class="list-tasks-group__process-insert-slot">
              <div class="list-tasks-group__process-insert-slot__line"></div>

              <div class="list-tasks-group__process-insert-slot__actions">
                <button
                  type="button"
                  class="list-tasks-group__process-insert-slot__action-btn list-tasks-group__process-insert-slot__action-btn--task"
                  (click)="onProcessInsertSelected(idx, 'task')"
                >
                  <mat-icon>check</mat-icon>
                </button>

                <button
                  type="button"
                  class="list-tasks-group__process-insert-slot__action-btn list-tasks-group__process-insert-slot__action-btn--message"
                  (click)="onProcessInsertSelected(idx, 'message')"
                >
                  <img src="./assets/img/ic-mail.svg" alt="add message" />
                </button>
              </div>
            </div>
          }

          <list-tasks-single-task
            [task]="task"
            [layout]="layout()"
            [groupId]="group().taskGroup.id"
            [isProcessGroup]="isProcessGroup()"
            status="created"
            (statusUpdated)="onTaskStatusChanged($event)"
            (taskClicked)="onTaskClicked($event)"
          />

          @if (isProcessGroup() && last) {
            <div class="list-tasks-group__process-insert-slot">
              <div class="list-tasks-group__process-insert-slot__line"></div>

              <div class="list-tasks-group__process-insert-slot__actions">
                <button
                  type="button"
                  class="list-tasks-group__process-insert-slot__action-btn list-tasks-group__process-insert-slot__action-btn--task"
                  (click)="onProcessInsertSelected(idx + 1, 'task')"
                >
                  <mat-icon>check</mat-icon>
                </button>

                <button
                  type="button"
                  class="list-tasks-group__process-insert-slot__action-btn list-tasks-group__process-insert-slot__action-btn--message"
                  (click)="onProcessInsertSelected(idx + 1, 'message')"
                >
                  <img src="./assets/img/ic-mail.svg" alt="add message" />
                </button>
              </div>
            </div>
          }
        }

        <div
          class="d-flex flex-column list-tasks-group__completed"
          [ngClass]="{ hidden: !getTargetCollection('completed').length }"
        >
          <h5 class="list-tasks-group__content__completed-title">Completed</h5>

          <div [dndDropzone]="isProcessGroup() ? [] : ['task']" (dndDrop)="onTaskDrop($event, 'completed')">
            <div dndPlaceholderRef class="dndPlaceholder"></div>

            @for (task of getTargetCollection('completed'); track task.id) {
              <list-tasks-single-task
                [task]="task"
                [layout]="layout()"
                [groupId]="group().taskGroup.id"
                [isProcessGroup]="isProcessGroup()"
                status="completed"
                (statusUpdated)="onTaskStatusChanged($event)"
                (taskClicked)="onTaskClicked($event)"
              />
            }
          </div>
        </div>

        <div
          class="d-flex flex-column list-tasks-group__cancelled"
          [ngClass]="{ hidden: !getTargetCollection('cancelled').length }"
        >
          <h5 class="list-tasks-group__content__cancelled-title">Cancelled</h5>

          <div [dndDropzone]="isProcessGroup() ? [] : ['task']" (dndDrop)="onTaskDrop($event, 'cancelled')">
            <div dndPlaceholderRef class="dndPlaceholder"></div>

            @for (task of getTargetCollection('cancelled'); track task.id) {
              <list-tasks-single-task
                [task]="task"
                [layout]="layout()"
                [groupId]="group().taskGroup.id"
                [isProcessGroup]="isProcessGroup()"
                status="cancelled"
                (statusUpdated)="onTaskStatusChanged($event)"
                (taskClicked)="onTaskClicked($event)"
              />
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
